import platformConfig from '/config/platform.config';
import {screenHeight} from '/constant/layout.constant';
import {nullComponentDefault} from '/util/defaultProps.util';

import {styles} from './ClientReportPopover.style';

export const getPopoverContent = (contentName: any, allContent: any) =>
  allContent[contentName] || nullComponentDefault;

export const getStyles = (safeAreaInsets: any, isLandscape = false) => {
  const popoverStyle = {
    base: {...styles.base},
    content: {
      maxHeight: isLandscape
        ? screenHeight() - 80
        : screenHeight() - safeAreaInsets.top - safeAreaInsets.bottom - 100,
    },
  };

  const footerButtonPadding =
    platformConfig.getOS() === 'ios'
      ? styles.footerButtonPaddingIos
      : styles.footerButtonPaddingAndroid;

  const footerButtonStyle = isLandscape
    ? {
        ...styles.footerButtons,
        paddingTop: 20,
        paddingBottom: 0,
      }
    : {
        ...styles.footerButtons,
        ...footerButtonPadding,
      };

  return {
    footerButtonStyle,
    popoverStyle,
  };
};
